// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"5c0c7b41","419":"9128f327","563":"750e85b2","654":"df1b6b0b","787":"aba1b661"}[chunkId] + ".chunk.js";
};